import React, { useState, useRef } from "react";

import {
  CCol,
  CRow,
  CFormGroup,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CInput
} from "@coreui/react";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";

// import StatisticsAccessFilter from "../../../components/Statistics/StatisticsAccess/StatisticsAccessFilter";

import URL from "../../../config/api";
import axios from "../../../config/axios";
import ModalContentDetails from "../../Statistics/StatisticsAccess/ModalContentDetails";
import StatisticsAccessFilter from "../../Statistics/StatisticsAccess/StatisticsAccessFilter";

import "./styles.css";
// import { set } from "core-js/library/fn/dict";

const CreateFilterOffline = ({
  applications,
  user,
  activity_id: activityId,
  printStatistic,
  getDate,
  getInfoSelectors,
  infoView,
  viewOfflineRegister,
  editOfflineRegister,
  isEditMode,
  isDailyMode
}) => {
  const token = useSelector(state => state.user.token);

  const [groupId, setGroupId] = useState(0);
  const [regionId, setRegionId] = useState(0);
  const [schoolId, setSchoolId] = useState(0);
  const [roomId, setRoomId] = useState(0);
  const [roleId, setRoleId] = useState(0);

  const [tableGroupSelected, setTableGroupSelected] = useState([]);
  const [tableRegionSelected, setTableRegionSelected] = useState([]);
  const [tableSchoolSelected, setTableSchoolSelected] = useState([]);
  const [tableRoomSelected, setTableRoomSelected] = useState([]);

  const [initialDay, setInitialDay] = useState();
  const [finalDay, setFinalDay] = useState();
  const [initialMonth, setInitialMonth] = useState();
  const [finalMonth, setFinalMonth] = useState();

  const [typePeriod, setTypePeriod] = useState("day");

  const [pageLoading, setPageLoading] = useState(false);

  const [data, setData] = useState(null);
  const [modal, setModal] = useState(false);
  const [contentDetails, setContentDetails] = useState(false);

  const table = useRef(null);

  const changeFilter = selected => {
    setRoomId(selected.roomId);
    setRoleId(selected.roleId);
    setGroupId(selected.groupId);
    setRegionId(selected.regionId);
    setSchoolId(selected.schoolId);
  };

  const onFilter = async () => {
    if (!groupId) {
      toastr.warning("Atenção", "Escolha um grupo");
      return;
    }

    if (typePeriod === "day" && (!initialDay || !finalDay)) {
      toastr.warning("Atenção", "Preencha o período");
      return;
    }

    if (typePeriod === "month" && (!initialMonth || !finalMonth)) {
      toastr.warning("Atenção", "Preencha o período");
      return;
    }

    setPageLoading(true);

    try {
      const res = await axios.get(`${URL.api}statistics/management`, {
        params: {
          group_id: groupId,
          region_id: regionId,
          school_id: schoolId,
          room_id: roomId,
          role_id: roleId,
          period: typePeriod,
          start: typePeriod === "day" ? initialDay : initialMonth,
          end: typePeriod === "day" ? finalDay : finalMonth
        },
        headers: { authorization: `Bearer ${token}` }
      });

      setData(res.data.data);

      setPageLoading(false);
    } catch (err) {
      toastr.error("Falha", "Não foi possível obter as estatísticas");
      setPageLoading(false);
    }
  };

  const getDateFilter = date => {
    getDate(date);
  };

  const onTypePeriodDay = () => {
    setTypePeriod("day");
  };

  const onTypePeriodMonth = () => {
    setTypePeriod("month");
  };

  const handleInitialDay = event => {
    setInitialDay(event.target.value);
    getDateFilter(event.target.value);
  };

  const handleFinalDay = event => {
    setFinalDay(event.target.value);
  };

  const handleInitialMonth = event => {
    setInitialMonth(event.target.value);
  };

  const handleFinalMonth = event => {
    setFinalMonth(event.target.value);
  };

  const handleGroupSelected = id => {
    let index = tableGroupSelected.indexOf(id);
    if (index !== -1) {
      setTableGroupSelected(newArray => newArray.filter(item => item !== id));
    } else {
      setTableGroupSelected(newArray => [...newArray, id]);
    }
  };

  const handleRegionSelected = id => {
    let index = tableRegionSelected.indexOf(id);
    if (index !== -1) {
      setTableRegionSelected(newArray => newArray.filter(item => item !== id));
    } else {
      setTableRegionSelected(newArray => [...newArray, id]);
    }
  };

  const handleSchoolSelected = id => {
    let index = tableSchoolSelected.indexOf(id);
    if (index !== -1) {
      setTableSchoolSelected(newArray => newArray.filter(item => item !== id));
    } else {
      setTableSchoolSelected(newArray => [...newArray, id]);
    }
  };

  const handleRoomSelected = id => {
    let index = tableRoomSelected.indexOf(id);
    if (index !== -1) {
      setTableRoomSelected(newArray => newArray.filter(item => item !== id));
    } else {
      setTableRoomSelected(newArray => [...newArray, id]);
    }
  };

  const showModal = (e, group = 0, region = 0, school = 0, room = 0) => {
    e.stopPropagation();

    setContentDetails({
      group_id: groupId || group,
      region_id: regionId || region,
      school_id: schoolId || school,
      room_id: roomId || room,
      role_id: roleId,
      period: typePeriod,
      start: typePeriod === "day" ? initialDay : initialMonth,
      end: typePeriod === "day" ? finalDay : finalMonth
    });

    setModal(true);
  };

  const getArrayCSV = data => {
    const header = [
      "tipo_de_unidade",
      "nome",
      "quantidade_usuarios",
      "quantidade_acessantes",
      "percentual_acessantes",
      "quantidade_acessos",
      "quantidade_conteudos",
      "quantidade_conteudos_acessados",
      "percentual_conteudos_acessados",
      "quantidade_acessos_conteudos"
    ];

    const arr = [header];

    data.forEach(group => {
      arr.push([
        "grupo",
        group.name,
        group.users,
        group.accessors,
        group.users_accessors,
        group.accesses,
        group.contents,
        group.accessed_contents,
        group.contents_accessed_contents,
        group.accesses_content
      ]);

      group.regions.forEach(region => {
        arr.push([
          "regional",
          region.name,
          region.users,
          region.accessors,
          region.users_accessors,
          region.accesses,
          region.contents,
          region.accessed_contents,
          region.contents_accessed_contents,
          region.accesses_content
        ]);

        region.schools.forEach(school => {
          arr.push([
            "escola",
            school.name,
            school.users,
            school.accessors,
            school.users_accessors,
            school.accesses,
            school.contents,
            school.accessed_contents,
            school.contents_accessed_contents,
            school.accesses_content
          ]);

          school.rooms.forEach(room => {
            arr.push([
              "turma",
              room.name,
              room.users,
              room.accessors,
              room.users_accessors,
              room.accesses,
              room.contents,
              room.accessed_contents,
              room.contents_accessed_contents,
              room.accesses_content
            ]);
          });
        });
      });
    });

    return arr;
  };

  return (
    <>
      {modal && (
        <ModalContentDetails
          show
          filter={contentDetails}
          onClose={() => setModal(false)}
        />
      )}
      <div
        className="d-flex flex-column align-items-left"
        style={{ marginBottom: "20px" }}
      >
        <div>
          <div>
            <CRow className="mb-0">
              <CCol style={{ maxWidth: "100%" }}>
                <StatisticsAccessFilter
                  onChange={changeFilter}
                  hideTeacher
                  isOfflineRegister
                  getInfoSelectors={getInfoSelectors}
                  viewOfflineRegister={viewOfflineRegister}
                  editOfflineRegister={editOfflineRegister}
                  infoView={infoView}
                  isEditMode={isEditMode}
                  isDailyMode={isDailyMode}
                  user={user}
                />
              </CCol>
            </CRow>
            <div className="d-flex w-100">
              <div className="flex-column w-100">
                <div>Data</div>
                <div className="d-flex w-100 align-items-center">
                  <div className="flex-1 d-flex align-items-center">
                    <CFormGroup className="m-0">
                      <CInputGroup className="input-prepend">
                        <>
                          <CInputGroupPrepend>
                            <CInputGroupText>
                              <i className="fa fa-clock-o"></i>
                            </CInputGroupText>
                          </CInputGroupPrepend>
                          <CInput
                            type="date"
                            onChange={handleInitialDay}
                            defaultValue={
                              viewOfflineRegister || editOfflineRegister
                                ? infoView.date.split(" ")[0]
                                : initialDay
                            }
                            value={initialDay}
                            disabled={viewOfflineRegister}
                          ></CInput>
                        </>
                      </CInputGroup>
                    </CFormGroup>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateFilterOffline;
